import { AbstractValidator } from "fluent-ts-validator";
import { observable, action } from "mobx";
import RouteList from "../../../infrastructure/RouteList";
import { routes } from "../../../router";
import Utils from "../../../infrastructure/Utils";
import UserContext from "../../../infrastructure/UserContext";
import { BaseAddEditViewModel } from "../../components/BaseAddEditViewModel";
import AgentStateLicensesStore from "../../../store/AgentStateLicensesStore";
import RouteParamDetails from "../../../infrastructure/RouteParamDetails";
import ContractsStore from "../../../store/ContractsStore";
import { any, bool, string } from "prop-types";
import Collection from "../../../infrastructure/CollectionHelper";
import DocumentStore from "../../../store/DocumentStore";
import { AgentListModel } from "../../../services/ProducerSearchService";
import { CustomAttributesComponentViewModel } from "../../../views/customers/CustomAttributesComponentViewModel";
import CustomAttributeStore from "../../../store/CustomAttributeStore";
import { Permission } from "../../../infrastructure/enum/Permission";
import PageContext from "../../../infrastructure/PageContext";
import { Constants } from "../../../infrastructure/enum/Constants";
import { CustAttrToEntityModel } from "../../../services/ContractService";
import { toast } from "react-toastify";
import { closeToasterButtonTemplate } from "../../../views/components/controls/IMASTemplates";
import StateLicenseStore from "../../../store/StateLicenseStore";
export class StateLicensesAddViewModel extends BaseAddEditViewModel {
  @observable IssueDate: Date | undefined;
  @observable ExpirationDate: Date | undefined;
  @observable neverExpiring: boolean = false;
  @observable isNeverExpiringEnabled: boolean = false;
  @observable agentId: number = 0;
  @observable stateLicense: string = "";
  @observable RenewalDate: Date | undefined;
  @observable notes: string = "";
  @observable isValid = true;
  @observable isValidationToasterVisible: boolean = false;
  @observable response: any;
  @observable resultDuplicate: boolean = false;
  @observable item: any;
  constructor() {
    super(
      "State License",
      routes.agentStateLicenses,
      new StateLicenseValidator()
    );
  }
  @observable stateList: any = [{ label: "Select State", value: "0" }];
  @observable ResidencyStatusList: any = [{ label: "Select", value: "0" }];
  @observable productLinesList: any;
  @observable StatusList: any = [{ label: "Select", value: "0" }];
  @observable ActionStatusList: any = [{ label: "Select", value: "0" }];
  @observable selectedState: string = "";
  @observable selectedProductline: any = null;
  @observable selectedResidencyStatus: string = "0";
  @observable selectedStatus: string = "0";
  @observable selectedActionStatus: string = "0";
  @observable FilteredDocumentList = new Collection<any>();
  @observable documentList = new Collection<any>();
  @observable selectedDocument: string = "";
  @observable selectedDocumentId: number = 0;
  @observable isException: boolean = false;
  @observable exceptionMessage: any;
  //custom attribute states
  @observable addAttributesModal: boolean = false;
  @observable
  CustomAttributesComponentViewModel: CustomAttributesComponentViewModel =
    new CustomAttributesComponentViewModel();
  @observable isCustomAttrActive: boolean = false;
  @observable attributesScreenPath: number = 1;
  @observable attributesScreenPathId: number = 1;
  @observable custAttrToEntityList = new Collection<CustAttrToEntityModel>();
  @observable customAttributeList: any = [];

  protected resetModel() {
    this.selectedProductline = [];
    this.selectedState = "0";
    this.IssueDate = undefined;
    this.ExpirationDate = undefined;
    this.RenewalDate = undefined;
    this.stateLicense = "";
    this.selectedResidencyStatus = "0";
    this.selectedStatus = "0";
    this.selectedActionStatus = "0";
    this.notes = "";
    this.documentList.values = [];
    this.selectedDocument = "";
    this.selectedDocumentId = 0;
    this.isCustomAttrActive = false;
    PageContext.isCustomAttribute = false;
    this.response = "";
    this.isNeverExpiringEnabled = false;
    this.neverExpiring = false;
  }
  protected toServiceModel() {
    var attrData = localStorage.getItem("CustomAttribute");
    var result = [];
    if (attrData) {
      result = JSON.parse(attrData);
      let custAttrToEntityData: any = [];
      this.custAttrToEntityList.values = [];
      result.forEach((result: any) => {
        var data = {
          customAttributeScreenId: result.custAttrScrnId,
          entityId: this.attributesScreenPathId,
          value: result.attrValue + "",
        };
        if (
          result.attrValue != null &&
          result.attrValue != "" &&
          result.attrValue != undefined
        ) {
          custAttrToEntityData.push(data);
        }
      });
      this.custAttrToEntityList.values = custAttrToEntityData;
    }
    return {
      id: this.selectedId,
      issueDate: Utils.getValidDate(this.IssueDate),
      expirationDate: Utils.getValidDate(this.ExpirationDate),
      agentId: parseInt("" + localStorage.getItem("agentIdForStateTab")),
      stateId: parseInt(this.selectedState),
      licenseLineOfAuthorityIds:
        this.selectedProductline.length > 0
          ? this.selectedProductline.map((i: any) => parseInt(i))
          : [],
      stateLicense: this.stateLicense,
      residencyStatusId: +this.selectedResidencyStatus,
      renewalDate: Utils.getValidDate(this.RenewalDate),
      stateLicenseStatusId: +this.selectedStatus,
      stateLicenseActionStatusId: +this.selectedActionStatus,
      notes: "" + this.notes,
      documentAttachmentList: this.documentList.values || undefined,
    };
  }

  protected async checkPermissions(): Promise<void> {
    localStorage.removeItem("CustomAttribute");
    // get Custom attribute screen permission
    var res = await this.getCustomAttributePermissionByScreen();
    if (res) {
      let data = res.filter(
        (x) =>
          x.path === Permission.AddEditStateLicensesScreen && x.active === true
      );
      this.isCustomAttrActive = data.length > 0 ? true : false;

      var attributes = await this.getCustomAttributesByScreen(1);
      if (attributes) {
        this.customAttributeList = attributes;
      }
      this.attributesScreenPathId = 1;
    }
  }
  protected async loadLookups(): Promise<void> {
    if (UserContext.userId && UserContext.userId > 0) {
      let result = await AgentStateLicensesStore.getAllStatesLookup();

      if (result) {
        if (this.stateList.length === 1) {
          var companies = [...result].sort(Utils.compareListItem);
          for (let item of companies) {
            this.stateList.push({
              label: "" + item.abbreviation,
              value: "" + item.stateId,
              isHeader: item.isHeader,
            });
          }
        }
      }

      let banks = await AgentStateLicensesStore.getProductLinesLookup();
      if (banks) {
        this.productLinesList = Utils.mapListItemsAsList(banks || [], "", "");
      }
      // Load Residency status
      var statuses = await ContractsStore.getAllResidencyStatus();
      if (statuses) {
        this.ResidencyStatusList = [];
        this.ResidencyStatusList = [{ label: "Select", value: "0" }].concat(
          this.mapListItemAndSort(statuses)
        );
      }
      // Load State License status
      var licenseStatuses = await StateLicenseStore.getAllStateLicenseStatus();
      if (licenseStatuses) {
        this.StatusList = [];
        this.StatusList = [{ label: "Select", value: "0" }].concat(
          this.mapListItemAndSort(licenseStatuses)
        );
      }

      this.ActionStatusList = [{ label: "Select", value: "0" }];
    }
  }

  @action async loadStateLicenseActionStatus(statusId: number) {
    // Load State License Action status
    var licenseActionStatus =
      await StateLicenseStore.getAllStateLicenseActionStatus(statusId);
    if (licenseActionStatus) {
      this.ActionStatusList = [];
      this.ActionStatusList = [{ label: "Select", value: "0" }].concat(
        this.mapListItemAndSort(licenseActionStatus)
      );
    }
  }

  @action mapListItemAndSort(listObjects: any) {
    if (listObjects) {
      var sortList = listObjects.sort(Utils.compareListItem);
      sortList.forEach((element: any) => {
        element.label = element.text;
      });
      return sortList;
    } else {
      return [];
    }
  }

  @action hideValidationToaster = () => {
    this.isValidationToasterVisible = false;
    toast.dismiss("validation-toaster");
  };

  protected async checkStateLicenseDuplicateByAgent() {
    this.resultDuplicate =
      await AgentStateLicensesStore.checkStateLicenseDuplicateByAgent(
        this.item.id,
        this.item.agentId,
        this.item.stateId,
        this.item.issueDate,
        this.item.expirationDate,
        this.item.stateLicense,
        undefined,
        undefined,
        this.item.stateLicenseStatusId,
        this.item.stateLicenseActionStatusId,
        undefined,
        this.item.licenseLineOfAuthorityIds.length > 0
          ? this.item.licenseLineOfAuthorityIds
          : null,
        undefined,
        undefined,
        undefined,
        undefined
      );

    if (!this.resultDuplicate) {
      if (this.item.id == 0) {
        this.item.id = await AgentStateLicensesStore.addStateLicense(this.item);
        if (
          Utils.hasUserPermission(Permission.PrivateCustomAttribute) ||
          Utils.hasUserPermission(Permission.PublicCustomAttribute)
        ) {
          await this.createUpdateAttributes();
        }
      } else {
        await AgentStateLicensesStore.editStateLicense(this.item);
      }
    } else {
      var data = "A state License record with the same details already exists.";
      toast.warning(`${data}`, {
        position: toast.POSITION.TOP_RIGHT,
        closeOnClick: true,
        closeButton: closeToasterButtonTemplate(this.hideValidationToaster),
        className: "validation-toaster contract",
        draggable: false,
        toastId: "validation-toaster",
      });
    }
  }

  protected async addItem(): Promise<void> {
    PageContext.isCustomAttribute = false;
    PageContext.isMessageVisible = false;
    this.response = "";
    var attrData = localStorage.getItem("CustomAttribute");
    var result = [];
    this.isValid = true;
    if (attrData) {
      result = JSON.parse(attrData);
      var mandatoryCustomAttributeData = result.filter(
        (x: any) =>
          x.isMandatory == true &&
          (x.attrValue == null || x.attrValue == "" || x.attrValue == undefined)
      );
      if (
        mandatoryCustomAttributeData != null &&
        mandatoryCustomAttributeData.length > 0
      ) {
        PageContext.isCustomAttribute = true;
        this.isValid = false;
        window.scrollTo(0, 0);
        var responseModel = {
          status: 400,
          title: Constants.CustomAttributeValidationMessage,
          errors: { "": [] },
        };
        this.response = JSON.stringify(responseModel);
      }
    }
    if (this.isValid) {
      this.item = this.toServiceModel();
      if (this.item) {
        await this.checkStateLicenseDuplicateByAgent();

        PageContext.currentPage = this.resultDuplicate;
      }
    }
  }

  protected async updateItem(): Promise<void> {
    PageContext.isMessageVisible = false;
    this.item = this.toServiceModel();
    if (this.item) {
      await this.checkStateLicenseDuplicateByAgent();
      PageContext.currentPage = this.resultDuplicate;
    }
  }

  @action setSelectState(value: string) {
    this.selectedState = value;
  }
  @action setSelectedProductline(value: any) {
    this.selectedProductline = value;
  }
  @action setNotes(value: string) {
    this.notes = value;
  }

  @action async getCustomAttributePermissionByScreen() {
    try {
      var res = await CustomAttributeStore.getAllScreens();
      return res;
    } catch (e) {
      throw e;
    }
  }
  @action async getCustomAttributesByScreen(screenId: number) {
    try {
      var res = await CustomAttributeStore.getAllAttributesByScreen(screenId);
      return res;
    } catch (e) {
      throw e;
    }
  }

  @action cancel() {
    localStorage.removeItem("CustomAttribute");
    routes.agentStateLicenses.replace({
      agentId: localStorage.getItem("agentIdForStateTab") || "0",
    });
  }

  @action
  private loaded = () => {
    this.loading = false;
  };

  Route = async (currentRoute: RouteList): Promise<void> => {
    var routeParams = JSON.parse(JSON.stringify(currentRoute.params));
    RouteParamDetails.agentId = routeParams.agentId;
    this.agentId = routeParams.agentId;
    localStorage.setItem("agentId", "" + this.agentId);
  };

  private paramCarrierID: number | undefined;
  private paramLicenseTypeId: number | undefined;

  @observable
  private loading = true;

  @action filterDocuments = async (value: string) => {
    let result = await DocumentStore.getAgentDocuments(
      parseInt("" + localStorage.getItem("agentIdForStateTab")) || 0,
      0,
      0,
      this.selectedDocument,
      0,
      100,
      "id",
      false,
      Utils.hasUserPermission(Permission.ManagePrivateAgentDocuments)
        ? null
        : false
    );
    var noAgent: AgentListModel = { id: 0 };
    if (result && result.recordCount && result.data) {
      let self = this;
      result.data =
        self.documentList.values &&
        result.data.filter((i) => {
          return (
            self.documentList.values.find(
              (j) =>
                j.documentName == i.documentName &&
                j.fileType == i.fileType &&
                !j.isDeleted
            ) == null
          );
        });
      result.recordCount = (result.data && result.data.length) || 0;
    }

    if (result !== null) {
      if (result.recordCount) {
        if (result.data) {
          result.data.splice(0, 0, {
            id: -1,
          });
          this.FilteredDocumentList.values = result.data;
          var element = document.querySelector(".p-autocomplete-panel");
          setTimeout(() => {
            if (element) {
              element.scrollTo(0, 0);
            }
          }, 10);
        }
      } else {
        this.FilteredDocumentList.values = [noAgent];
        this.selectedDocument = "";
      }
    }
  };

  @action downloadDocumentLink = async (docId: number, filename: string) => {
    this.isLoading = true;
    this.isException = false;
    this.exceptionMessage = {};
    try {
      var result = await DocumentStore.downloadFiles(docId, 0, true);
      if (result != null) {
        if (result.data) {
          Utils.downloadDocumentFile(
            result.data,
            result.fileName !== null && result.fileName !== undefined
              ? result.fileName
              : filename,
            result.headers ? result.headers["content-type"] : result.data.type
          );
        }
      }
    } catch (e: any) {
      this.isException = true;
      this.exceptionMessage = e.response;
    }
    this.isLoading = false;
  };

  @action deleteDocument(rowId: any, mappingId: any) {
    let document: any;
    if (rowId && rowId > 0 && mappingId == 0) {
      this.documentList.values = this.documentList.values.filter((item) => {
        return item.rowId != rowId;
      });
    } else if (mappingId && mappingId > 0) {
      document = this.documentList.values.filter((item) => {
        return item.mappingId == mappingId;
      });

      if (document && document.length > 0) {
        document[0].isDeleted = true;
      }
    }
  }

  @action setSelectedDocument(value: any) {
    this.selectedDocument = value;
  }

  // custom attribute methods
  @action handleAttributesModal = (value: boolean) => {
    this.addAttributesModal = value;
    setTimeout(async () => {
      value &&
        this.CustomAttributesComponentViewModel.loadExistingAttributes(1);
      !value && this.CustomAttributesComponentViewModel.resetAttributes();
    }, 900);
  };

  @action AttributeSave = async (type: number) => {
    let data = await this.CustomAttributesComponentViewModel.saveAttribute(
      type
    );
    this.addAttributesModal = false;

    setTimeout(async () => {
      var attributes = await this.getCustomAttributesByScreen(1);
      if (attributes) {
        this.customAttributeList = attributes;
      }
      this.CustomAttributesComponentViewModel.resetAttributes();
    }, 900);
  };

  @action createUpdateAttributes = async () => {
    let data: any = [];
    (this.customAttributeList || []).map((item: any) => {
      item.attrValue =
        item.dataTypeId == 6
          ? item.attrValue
            ? Utils.getDateInFormat(new Date(item.attrValue))
            : ""
          : item.attrValue;
      data.push({
        customAttributeScreenId: item.scrnCustAttrId || 0,
        entityId: this.item.id || 0,
        value: item.attrValue + "",
      });
    });

    let res = await CustomAttributeStore.saveCustomAttributes(data);
  };
}

class StateLicenseValidator extends AbstractValidator<StateLicensesAddViewModel> {
  public constructor() {
    super();
    this.validateIfString((input) => input.selectedState)
      .isNotEmpty()
      .isNotEqualTo("0")
      .withFailureMessage("Please select State");
    // this.validateIfString((input) => input.selectedProductline)
    //   .isNotEmpty()
    //   .isNotEqualTo("-1")
    //   .withFailureMessage("Please select Line of Authority");
    this.validateIfString((input) => input.stateLicense)
      .isNotEmpty()
      .isNotEqualTo("-1")
      .withFailureMessage("Enter State License #");

    this.validateIfDate((input) => input.IssueDate)
      .isNotEmpty()
      .isNotNull()
      .isNotEqualTo(undefined)
      .withFailureMessage("Please select Start Date");

    this.validateIfString((input) => input.selectedStatus)
      .isNotEmpty()
      .isNotEqualTo("0")
      .withFailureMessage("Please select Status");

    this.validateIfDate((input) => input.ExpirationDate)
      .isNotEmpty()
      .withFailureMessage("Expiration Date is required");
  }
}
